export const MODAL_TYPE_DEMO_MODE = 'demo-modal';
